export default __webpack_public_path__ + "static/media/logo_citf.4b90e2bc.png";